module.exports = __webpack_public_path__ + "img/animal_chara_mogura_kouji_ana.ff9b58fa.png";